import { FC, lazy, useMemo } from 'react';
import {
  UserRoleValue,
  UsersRequestParams,
} from 'src/apis/organisation-service/types';
import { PageSpinner } from 'src/components/spinner-container';
import { Successful } from 'src/hooks/use-axios';
import { OrganisationServiceRequest } from 'src/pages/settings/organisation/use-organisation-service';
import { usePageParams } from 'src/pages/settings/organisation/users/use-page-params';
import { useUsers } from 'src/pages/settings/organisation/users/use-users';
import { Forbidden } from 'src/utils/errors';

const Page = lazy(() => import('src/pages/settings/organisation/users/page'));

type Props = {
  organisationService: Successful<OrganisationServiceRequest>;
};

export const UsersOverview: FC<Props> = ({ organisationService }) => {
  if (!organisationService.response.data._links.getAllOrganisationUsers)
    throw new Forbidden();

  const pageParams = usePageParams();

  const params = useMemo(
    () =>
      ({
        sortBy: pageParams.value.sortBy,
        sortDirection: pageParams.value.sortDirection,
        limit: pageParams.value.pageSize,
        offset: pageParams.value.start,
        name: pageParams.value.name,
        email: pageParams.value.email,
        status: pageParams.value.status,
        role: pageParams.value.role as UserRoleValue | null,
      }) satisfies UsersRequestParams,
    [pageParams.value]
  );
  const users = useUsers({
    url: organisationService.response.data._links.getAllOrganisationUsers.href,
    params,
  });

  if (!users.response) return <PageSpinner />;

  return <Page users={users} pageParams={pageParams} />;
};
